module.exports = __webpack_public_path__ + "static/media/gcww.b05175f5.jpg";